export const VENDOR = "vendorIds";
export const DATE_RANGE = "dateRange";
export const POSTED_START_DATE = "postedStartDate";
export const POSTED_END_DATE = "postedEndDate";
